import { MidTermPlan } from '@/components/enpages/Ir/Library/MidTermPlan'

export default MidTermPlan
